import _ from 'underscore';

import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import { IRemoteRefreshSchedulesResult } from '../ServerApi/requests/GetRemoteRefreshSchedulesRequest';
import { IRemoteRefreshSchedule } from '../ServerApi/types/IRemoteRefreshSchedule';

export module RemoteRefreshScheduleMapper {

  export function mapToResource(remoteRefreshSchedulesResult: IRemoteRefreshSchedulesResult): IRemoteRefreshScheduleInfo[] {

    return _.map(remoteRefreshSchedulesResult.schedules, (schedule: IRemoteRefreshSchedule): IRemoteRefreshScheduleInfo => {
      return {
        id: schedule.definition, // the APIs for remote refresh schedules do not expose an ID, but VPC depends on one
        contentType: 'remoteRefreshSchedule',
        definition: schedule.definition,
        scheduleDetails: schedule.scheduleDetails,
        scheduleType: schedule.scheduleType,
        timeZone: schedule.timeZone,
        refreshType: schedule.refreshType,
        runNextAt: schedule.runNextAt,
        lastRunAt: schedule.lastRunAt,
        expectedRefreshDuration: remoteRefreshSchedulesResult.expectedRefreshDuration
      };
    });
  }

  export function mapToApi(schedules: IRemoteRefreshScheduleInfo[]): IRemoteRefreshSchedule[] {
    return _.map(schedules, (schedule: IRemoteRefreshScheduleInfo): IRemoteRefreshSchedule => {
      return this.mapSingleToApi(schedule);
    });
  }

  export function mapSingleToApi(schedule: IRemoteRefreshScheduleInfo): IRemoteRefreshSchedule {
    return {
      definition: schedule.definition,
      scheduleDetails: schedule.scheduleDetails,
      scheduleType: schedule.scheduleType,
      timeZone: schedule.timeZone,
      refreshType: schedule.refreshType
    };
  }

}
